// @flow strict
import * as React from "react";

type Props = {|+children: React.Node, +onClick: () => void|};
export default function Button({children, onClick}: Props) {
  return <button onClick={onClick}>{children}</button>;
}
